import React from 'react';
import PartnersCtaButton from '../components/PartnersCtaButton';
import PartnersSectionHeading from '../components/PartnersSectionHeading';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersExclusivity: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section className="container-chisme py-10 lg:py-16">
      <PartnersSectionHeading
        title={
          <>
            <span className="block">{s.exclusivity.titleLine1}</span>
            <span className="block italic text-chisme-primary">{s.exclusivity.titleLine2}</span>
          </>
        }
        subtitle={s.exclusivity.subtitle}
      />

      <div className="mt-8 flex flex-wrap justify-center gap-2">
        {s.exclusivity.categories.map((category) => (
          <span
            key={category}
            className="rounded-full border border-[rgba(74,33,71,0.1)] bg-white px-4 py-2 font-jakarta text-sm font-medium text-[#5a3158]"
          >
            {category}
          </span>
        ))}
      </div>

      <div className="mt-12 grid gap-4 sm:grid-cols-3">
        {s.exclusivity.points.map((point) => (
          <div
            key={point.title}
            className="rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white p-6"
          >
            <h3 className="font-instrument text-xl italic text-[#2a0f2a]">{point.title}</h3>
            <p className="mt-2 font-jakarta text-[14.5px] leading-relaxed text-[#5a3158]">
              {point.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-10 text-center">
        <p className="font-jakarta text-[#5a3158]">{s.exclusivity.footnote}</p>
        <div className="mt-6">
          <PartnersCtaButton>{s.cta.registerBusiness}</PartnersCtaButton>
        </div>
      </div>
    </section>
  );
};

export default PartnersExclusivity;
